/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_UpdateCoursePlanRequest = {
    course_id: string;
    day_of_week?: number;
    effective_from: string;
    effective_until?: string;
    end_time: string;
    group_ids?: Array<string>;
    max_capacity?: number;
    recurrence_rule: courses_UpdateCoursePlanRequest.recurrence_rule;
    start_time: string;
    version: number;
};
export namespace courses_UpdateCoursePlanRequest {
    export enum recurrence_rule {
        WEEKLY = 'weekly',
        BIWEEKLY = 'biweekly',
        MONTHLY = 'monthly',
        ONCE = 'once',
    }
}

